import { ArrowLeft } from 'lucide-react';

export default function PrivacyPage() {
  return (
    <div style={{
      minHeight: '100vh',
      background: '#0a0a0a',
      color: '#e0e0e0',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      {/* Header */}
      <header style={{
        padding: '1rem 2rem',
        borderBottom: '1px solid #1a1a1a',
        display: 'flex',
        alignItems: 'center',
        gap: '1rem'
      }}>
        <a
          href="/"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            color: '#888',
            textDecoration: 'none',
            fontSize: '0.9rem'
          }}
        >
          <ArrowLeft size={18} />
          Back to Home
        </a>
      </header>

      {/* Content */}
      <main style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '3rem 2rem'
      }}>
        <h1 style={{
          fontSize: '2.5rem',
          fontWeight: '700',
          marginBottom: '0.5rem',
          color: '#fff'
        }}>
          Privacy Policy
        </h1>
        <p style={{ color: '#666', marginBottom: '3rem' }}>
          Last updated: January 23, 2026
        </p>

        <div style={{ lineHeight: '1.8', color: '#aaa' }}>
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '1rem' }}>
              1. Introduction
            </h2>
            <p>
              Work Van ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy
              explains how we collect, use, disclose, and safeguard your information when you use our
              field service management platform.
            </p>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '1rem' }}>
              2. Information We Collect
            </h2>
            <p style={{ marginBottom: '1rem' }}>
              <strong style={{ color: '#e0e0e0' }}>Account Information:</strong> When you create an account,
              we collect your name, email address, phone number, company name, and password.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              <strong style={{ color: '#e0e0e0' }}>Customer Data:</strong> Information you enter about your
              customers, including names, addresses, phone numbers, email addresses, and service history.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              <strong style={{ color: '#e0e0e0' }}>Business Data:</strong> Quotes, invoices, job records,
              schedules, photos, and communications you create using the Service.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              <strong style={{ color: '#e0e0e0' }}>Payment Information:</strong> When you subscribe or process
              payments, our payment processor (Stripe) collects payment card information. We do not store
              full credit card numbers on our servers.
            </p>
            <p>
              <strong style={{ color: '#e0e0e0' }}>Usage Data:</strong> We automatically collect information
              about how you interact with the Service, including IP address, browser type, pages visited,
              and timestamps.
            </p>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '1rem' }}>
              3. How We Use Your Information
            </h2>
            <p style={{ marginBottom: '1rem' }}>We use the information we collect to:</p>
            <ul style={{ paddingLeft: '1.5rem', marginBottom: '1rem' }}>
              <li style={{ marginBottom: '0.5rem' }}>Provide, maintain, and improve the Service</li>
              <li style={{ marginBottom: '0.5rem' }}>Process transactions and send related information</li>
              <li style={{ marginBottom: '0.5rem' }}>Send you technical notices, updates, and support messages</li>
              <li style={{ marginBottom: '0.5rem' }}>Respond to your comments, questions, and requests</li>
              <li style={{ marginBottom: '0.5rem' }}>Monitor and analyze trends, usage, and activities</li>
              <li>Detect, investigate, and prevent fraudulent or unauthorized activities</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '1rem' }}>
              4. Information Sharing
            </h2>
            <p style={{ marginBottom: '1rem' }}>We may share your information with:</p>
            <ul style={{ paddingLeft: '1.5rem', marginBottom: '1rem' }}>
              <li style={{ marginBottom: '0.5rem' }}>
                <strong style={{ color: '#e0e0e0' }}>Service Providers:</strong> Third parties that perform
                services on our behalf (payment processing, email delivery, SMS services, hosting)
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <strong style={{ color: '#e0e0e0' }}>Legal Requirements:</strong> When required by law or to
                respond to legal process
              </li>
              <li>
                <strong style={{ color: '#e0e0e0' }}>Business Transfers:</strong> In connection with a merger,
                acquisition, or sale of assets
              </li>
            </ul>
            <p>
              We do not sell your personal information to third parties.
            </p>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '1rem' }}>
              5. Data Security
            </h2>
            <p>
              We implement appropriate technical and organizational measures to protect your information
              against unauthorized access, alteration, disclosure, or destruction. This includes encryption
              of data in transit and at rest, secure authentication, and regular security assessments.
            </p>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '1rem' }}>
              6. Data Retention
            </h2>
            <p>
              We retain your information for as long as your account is active or as needed to provide
              you services. You may request deletion of your account and associated data at any time
              through your account settings or by contacting us.
            </p>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '1rem' }}>
              7. Your Rights
            </h2>
            <p style={{ marginBottom: '1rem' }}>Depending on your location, you may have the right to:</p>
            <ul style={{ paddingLeft: '1.5rem', marginBottom: '1rem' }}>
              <li style={{ marginBottom: '0.5rem' }}>Access the personal information we hold about you</li>
              <li style={{ marginBottom: '0.5rem' }}>Request correction of inaccurate information</li>
              <li style={{ marginBottom: '0.5rem' }}>Request deletion of your information</li>
              <li style={{ marginBottom: '0.5rem' }}>Object to processing of your information</li>
              <li>Request a portable copy of your data</li>
            </ul>
            <p>
              To exercise these rights, please contact us at{' '}
              <a href="mailto:privacy@workvanapp.com" style={{ color: '#F05A28' }}>
                privacy@workvanapp.com
              </a>
            </p>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '1rem' }}>
              8. Cookies and Tracking
            </h2>
            <p>
              We use cookies and similar technologies to maintain your session, remember your preferences,
              and analyze usage patterns. You can control cookie settings through your browser, though
              some features of the Service may not function properly if cookies are disabled.
            </p>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '1rem' }}>
              9. Third-Party Services
            </h2>
            <p>
              Our Service integrates with third-party services including Stripe (payments), Twilio (SMS),
              and Resend (email). These services have their own privacy policies, and we encourage you
              to review them.
            </p>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '1rem' }}>
              10. Children's Privacy
            </h2>
            <p>
              The Service is not intended for individuals under the age of 18. We do not knowingly collect
              personal information from children. If you believe we have collected information from a child,
              please contact us immediately.
            </p>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '1rem' }}>
              11. Changes to This Policy
            </h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any changes by
              posting the new policy on this page and updating the "Last updated" date. Continued use of
              the Service after changes constitutes acceptance of the updated policy.
            </p>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '1rem' }}>
              12. Contact Us
            </h2>
            <p>
              If you have questions about this Privacy Policy or our data practices, please contact us at:{' '}
              <a href="mailto:privacy@workvanapp.com" style={{ color: '#F05A28' }}>
                privacy@workvanapp.com
              </a>
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer style={{
        borderTop: '1px solid #1a1a1a',
        padding: '2rem',
        textAlign: 'center',
        color: '#666',
        fontSize: '0.85rem'
      }}>
        © 2026 WorkVan. All rights reserved.
      </footer>
    </div>
  );
}
